export const SortByMostBoughtSelect = {
  id: 'sort-by-most-bought-select',
  contentTypeId: 'dynamic-elements-filter-select',
  data: {
    options: [
      {
        name: '1',
        displayName: 'Most Bought First',
      },
      {
        name: '0',
        displayName: 'Least Bought First',
      },
    ],
  },
  inputs: {
    filterItem: {
      provider: 'self',
      property: 'options',
      transform: function (options: any) {
        return {
          isSingle: true,
          values: options,
        };
      }.toString(),
    },
    activeValues: {
      provider: 'id:root',
      property: 'selectedSortByMostBought',
      startWith: ['1'],
      transform: function ($event: any) {
        return window.neoclesDynamicFramework.recommendationsPanels.methods.isNonNullish(
          $event,
        )
          ? $event
          : ['1'];
      }.toString(),
    },
    allowShowAll: false,
    selectedValuesAsLabel: true,
    selectSingleValueByDefault: true,
  },
  styles: {
    dynamicVariables: {
      provider: 'id:root',
      property: 'filterSelectVariables',
    },
  },
};
